export default __webpack_public_path__ + "85d13f4c3dea3b86f4bc24c539ed8684.png";